import { BillingSeatType, SubscriptionTier } from '@heidi/schema/ml-scribe';
import type { UserBillingInfo } from '../../contracts';

export function isClinicianMaxBillingSeat(
  billingInfo: Pick<UserBillingInfo, 'seat_type' | 'new_product_tier'> | null | undefined
): boolean {
  return (
    billingInfo?.seat_type === BillingSeatType.MAX &&
    billingInfo?.new_product_tier === SubscriptionTier.CLINICIAN_PRO
  );
}
